var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-modal"},[_c('div',{staticClass:"common-modal-mask"}),_c('div',{staticClass:"common-modal-box gradient-border",style:(_vm.styleOption)},[_vm._t("default"),_c('span',{staticClass:"common-modal-close",on:{"click":_vm.closeModal}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }